<template>
  <SectionTemplate
    class="interact-section"
    title="从创作到互动，有言一站式PPT智能升级工具"
    :desc="sectionDesc"
    theme="dark"
  >
    <div class="interact-section__card-list">
      <EditCard :data="cardList[0]">
        <template #btn>
          <div class="interact-section__card-btns">
            <ArrowBtn
              class="interact-section__card-btn"
              text="免费试用"
              variant="purple-common"
              @click="handlePPTSpeak"
            />
            <Button
              class="interact-section__card-btn"
              variant="border-white-middle"
              @click="navigateTo('/ppt-speak')"
              >查看详情</Button
            >
          </div>
        </template>
      </EditCard>
      <EditCard :data="cardList[1]">
        <template #btn>
          <div class="interact-section__card-btns">
            <ArrowBtn
              class="interact-section__card-btn"
              text="免费试用"
              variant="purple-common"
              @click="handlePPTVideo"
            />
            <Button
              class="interact-section__card-btn"
              variant="border-white-middle"
              @click="() => navigateTo('/ppt-or-pdf-to-video')"
              >查看详情</Button
            >
          </div>
        </template>
      </EditCard>
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import Button from '@/design/components/buttons/base.vue';
import EditCard from '@/design/components/edit-card/index.vue';
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';

const sectionDesc = `与AIPPT协同，有言还提供从PPT转视频功能到ChatPPT可交互智能体的完整工具链，全面解放您的生产力。`;

const cardList = [
  {
    title: 'PPT Speak',
    des: '上传你的PPT，有言自动生成可问答互动的3D数字人智能体，告别单向视频播放，知识真正活起来。独有的PPT智能知识库与双模式体验，让内容从“被动灌输”变为“主动探索”。',
    path: getFeUrl(
      '/youyan-platform/ai-ppt/interact/ppt-speak.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: 'PPT生成视频',
    des: '上传你的PPT，或使用有言的AIPPT功能，无需专业学习即可轻松生成高质量的PPT数字人讲解视频。有言提供数千个人物形象，数百中声音和数十种语言，满足您的个性化内容需求。',
    path: getFeUrl(
      '/youyan-platform/ai-ppt/interact/ppt-video.jpg?x-oss-process=image/format,webp',
    ),
  },
];

const handlePPTSpeak = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/editor/page/chat`))}`,
      {
        open: {
          target: '_blank',
        },
      },
    );
  } else {
    navigateTo('/editor/page/chat', {
      open: {
        target: '_blank',
      },
    });
  }
};

const handlePPTVideo = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/editor/get-started?id=4`))}`,
      {
        open: {
          target: '_blank',
        },
      },
    );
  } else {
    navigateTo('/editor/get-started?id=4', {
      open: {
        target: '_blank',
      },
    });
  }
};
</script>

<style lang="scss" scoped>
.interact-section {
  background-color: var(--x-text-1);
}
.interact-section__card-list {
  display: flex;
  gap: 40px;
  align-items: center;
}
.interact-section__card-btns {
  display: flex;
  align-items: center;
  gap: 24px;
}
.interact-section__card-btn {
  width: 178px;
}
</style>
